<template>
  <section class="invoice-preview-wrapper">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-invoice-list'}"
        >
          Invoice List
        </b-link>
        for other invoices.
      </div>
    </b-alert>

    <b-row
      class="invoice-preview"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">

            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <logo />
                </div>
                <p class="card-text mb-25">
                  {{ invoice.address }}
                </p>
                <p class="card-text mb-0">
                  {{ invoice.phone }}
                </p>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  Invoice
                  <span class="invoice-number" />
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    Date Issued:
                  </p>
                  <p class="invoice-date">
                    {{ invoice.order_date }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">
                    Due Date:
                  </p>
                  <p class="invoice-date">
                    {{ invoice.due_date }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Invoice Client & Payment Details -->
          <b-card-body
            class="invoice-padding pt-0"
          >
            <b-row class="invoice-spacing">

              <!-- Col: Invoice To -->
              <b-col
                cols="12"
                xl="6"
                class="p-0"
              >
                <h6 class="mb-2">
                  Invoice To:
                </h6>
                <h6 class="mb-25">
                  Phone : {{ invoice.phone }}
                </h6>
                <p class="card-text mb-25">
                  Email : {{ invoice.email }}
                </p>
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">
                    Payment Details:
                  </h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">
                          Bank name:
                        </td>
                        <td>{{ invoice.payment }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>

              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3"
                order="2"
                order-md="1"
              >
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Products:</span>
                </b-card-text>
              </b-col>
              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Total Price:
                    </p>
                    <p class="invoice-total-amount">
                      {{ invoice.total_price }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in JSON.parse(invoice.products)">
                <td>{{ item.name }}</td>
                <td>{{ item.price }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">Note: </span>
            <span>{{ invoice.note }}</span>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

<!--          &lt;!&ndash; Button: Send Invoice &ndash;&gt;-->
<!--          <b-button-->
<!--            v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
<!--            v-b-toggle.sidebar-send-invoice-->
<!--            variant="primary"-->
<!--            class="mb-75"-->
<!--            block-->
<!--          >-->
<!--            Send Invoice-->
<!--          </b-button>-->

<!--          &lt;!&ndash; Button: DOwnload &ndash;&gt;-->
<!--          <b-button-->
<!--            v-ripple.400="'rgba(186, 191, 199, 0.15)'"-->
<!--            variant="outline-secondary"-->
<!--            class="mb-75"-->
<!--            block-->
<!--          >-->
<!--            Download-->
<!--          </b-button>-->

<!--          &lt;!&ndash; Button: Print &ndash;&gt;-->
<!--          <b-button-->
<!--            v-ripple.400="'rgba(186, 191, 199, 0.15)'"-->
<!--            variant="outline-secondary"-->
<!--            class="mb-75"-->
<!--            block-->
<!--          >-->
<!--            Print-->
<!--          </b-button>-->

<!--          &lt;!&ndash; Button: Edit &ndash;&gt;-->
<!--          <b-button-->
<!--            v-ripple.400="'rgba(186, 191, 199, 0.15)'"-->
<!--            variant="outline-secondary"-->
<!--            class="mb-75"-->
<!--            block-->
<!--            :to="{ name: 'apps-invoice-edit', params: { id: $route.params.id } }"-->
<!--          >-->
<!--            Edit-->
<!--          </b-button>-->

<!--          &lt;!&ndash; Button: Add Payment &ndash;&gt;-->
<!--          <b-button-->
<!--            v-b-toggle.sidebar-invoice-add-payment-->
<!--            v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
<!--            variant="success"-->
<!--            class="mb-75"-->
<!--            block-->
<!--          >-->
<!--            Add Payment-->
<!--          </b-button>-->
          <b-button
              v-b-toggle.sidebar-invoice-add-payment
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mb-75"
              block
          >
            Pay Now
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <invoice-sidebar-send-invoice :invoice="this.invoice" />
    <invoice-sidebar-add-payment :invoice="this.invoice" />
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex/dist/vuex.esm.browser'
import InvoiceSidebarSendInvoice from '../InvoiceSidebarSendInvoice.vue'
import InvoiceSidebarAddPayment from '../InvoiceSidebarAddPayment.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,

    Logo,
    InvoiceSidebarAddPayment,
    InvoiceSidebarSendInvoice,
  },
  data() {
    return {
      invoice: null,
    }
  },
  created() {
    this.getInvoice(this.$route.params.id).then(res => {
      console.log('RES invoice', res)
      this.invoice = res.data.data
    })
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {},
  methods: {
    ...mapActions(['getInvoice']),
    getProducts($list) {

    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style scoped>
.navbar{
  display: none !important;
}
.main-menu, .footer{
  display: none !important;
}
html[dir=ltr] .content{
  margin: 0 100px !important;
}
</style>
